{
  "name": "nha-wizard-frontend",
  "version": "2.0.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start_glane": "ng serve --configuration=glane --proxy-config proxy.conf.json --host 0.0.0.0",
    "start_gm_sense": "ng serve --configuration=gnsense --proxy-config proxy.conf.json --host 0.0.0.0",
    "start_rsscdc": "ng serve --configuration=rsscdc --proxy-config proxy.conf.json --host 0.0.0.0",
    "start_broye": "ng serve --configuration=broye --proxy-config proxy.conf.json --host 0.0.0.0",
    "build_glane": "ng build --configuration=production,glane",
    "build_gnsense": "ng build --configuration=production,gnsense",
    "build_rsscdc": "ng build --configuration=production,rsscdc",
    "build_broye": "ng build --configuration=production,broye",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "e2e": "ng e2e",
    "extract-i18n": "ng extract-i18n --format=xlf --output-path=src/i18n",
    "start-de": "ng serve --configuration=de",
    "temp": "ng add ng-extract-i18n-merge"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "20.3.12",
    "@angular/common": "20.3.12",
    "@angular/compiler": "20.3.12",
    "@angular/core": "20.3.12",
    "@angular/forms": "20.3.12",
    "@angular/localize": "^20.3.12",
    "@angular/platform-browser": "20.3.12",
    "@angular/platform-browser-dynamic": "20.3.12",
    "@angular/router": "20.3.12",
    "@ngrx/effects": "^20.1.0",
    "@ngrx/operators": "^20.1.0",
    "@ngrx/router-store": "^20.1.0",
    "@ngrx/store": "^20.1.0",
    "@ngrx/store-devtools": "^20.1.0",
    "@sentry/angular": "^9.10.1",
    "bootstrap": "^4.6.2",
    "core-js": "^2.4.1",
    "ng-extract-i18n-merge": "^3.1.0",
    "ngrx-store-freeze": "^0.2.4",
    "ngx-bootstrap": "^12.0.0",
    "ngx-loading": "17.0.0",
    "rxjs": "7.8.2",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.10",
    "@angular-eslint/builder": "20.6.0",
    "@angular-eslint/eslint-plugin": "20.6.0",
    "@angular-eslint/eslint-plugin-template": "20.6.0",
    "@angular-eslint/schematics": "20.6.0",
    "@angular-eslint/template-parser": "20.6.0",
    "@angular/build": "^20.3.10",
    "@angular/cli": "^20.3.10",
    "@angular/compiler-cli": "20.3.12",
    "@angular/language-service": "20.3.12",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "~2.0.2",
    "@types/node": "^12.11.1",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "angular-eslint": "20.6.0",
    "eslint": "^9.28.0",
    "jasmine-core": "~3.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "protractor": "~7.0.0",
    "ts-node": "~4.1.0",
    "typescript": "5.9.3",
    "typescript-eslint": "^8.33.1"
  },
  "browserslist": [
    "> 0.5%",
    "last 2 versions",
    "Firefox ESR",
    "not dead",
    "not IE 9-11"
  ]
}
